<!-- Breadcrumb -->
<div class="mb-[25px] md:flex items-center justify-between">
    <h5 class="!mb-0">
        Checkboxes & Radios
    </h5>
    <ol class="breadcrumb mt-[12px] md:mt-0">
        <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
            <a routerLink="/dashboard" class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
                <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-lg -mt-px text-primary-500 top-1/2 -translate-y-1/2">
                    home
                </i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
            Forms
        </li>
        <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
            Checkboxes & Radios
        </li>
    </ol>
</div>

<!-- Checkboxes & Radios -->
<div class="grid grid-cols-1 lg:grid-cols-2 gap-[25px] mb-[25px]">
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
        <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
            <div class="trezo-card-title">
                <h5 class="!mb-0">
                    Checkbox
                </h5>
            </div>
        </div>
        <div class="trezo-card-content">
            <div class="form-check flex items-center gap-[8px] mb-[10px] last:mb-0">
                <input type="checkbox" class="cursor-pointer" id="defaultCheckbox">
                <label for="defaultCheckbox" class="cursor-pointer">
                    Default checkbox
                </label>
            </div>
            <div class="form-check flex items-center gap-[8px] mb-[10px] last:mb-0">
                <input type="checkbox" checked class="cursor-pointer" id="checkedCheckbox">
                <label for="checkedCheckbox" class="cursor-pointer">
                    Checked checkbox
                </label>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
        <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
            <div class="trezo-card-title">
                <h5 class="!mb-0">
                    Disabled Checkbox
                </h5>
            </div>
        </div>
        <div class="trezo-card-content">
            <div class="form-check flex items-center gap-[8px] mb-[10px] last:mb-0">
                <input type="checkbox" id="disabledCheckbox" disabled>
                <label for="disabledCheckbox">
                    Disabled checkbox
                </label>
            </div>
            <div class="form-check flex items-center gap-[8px] mb-[10px] last:mb-0">
                <input type="checkbox" checked id="disabledCheckedCheckbox" disabled>
                <label for="disabledCheckedCheckbox">
                    Disabled checked checkbox
                </label>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
        <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
            <div class="trezo-card-title">
                <h5 class="!mb-0">
                    Radios
                </h5>
            </div>
        </div>
        <div class="trezo-card-content">
            <div class="form-radio flex items-center gap-[8px] mb-[10px] last:mb-0">
                <input type="radio" class="cursor-pointer" name="flexRadioDefault" id="flexRadioDefault1">
                <label for="flexRadioDefault1" class="cursor-pointer">
                    Default radio
                </label>
            </div>
            <div class="form-radio flex items-center gap-[8px] mb-[10px] last:mb-0">
                <input type="radio" checked class="cursor-pointer" name="flexRadioDefault" id="flexRadioDefault2">
                <label for="flexRadioDefault2" class="cursor-pointer">
                    Default checked radio
                </label>
            </div>
        </div>
    </div>
    <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
        <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
            <div class="trezo-card-title">
                <h5 class="!mb-0">
                    Disabled Radios
                </h5>
            </div>
        </div>
        <div class="trezo-card-content">
            <div class="form-radio flex items-center gap-[8px] mb-[10px] last:mb-0">
                <input type="radio" name="disabledFlexRadioDefault" id="disabledFlexRadioDefault1" disabled>
                <label for="disabledFlexRadioDefault1">
                    Disabled radio
                </label>
            </div>
            <div class="form-radio flex items-center gap-[8px] mb-[10px] last:mb-0">
                <input type="radio" checked name="disabledFlexRadioDefault" id="disabledFlexRadioDefault2" disabled>
                <label for="disabledFlexRadioDefault2">
                    Disabled checked radio
                </label>
            </div>
        </div>
    </div>
</div>